/** @format */

export const ALL_CATEGORY_ID = 0
export const LEGACY_ALL_CATEGORY_ID = 6
export const FORMS_KEYWORD = 'forms'

export function isFormsCategory(category) {
  const title = category?.title || ''
  return title.toLowerCase().includes(FORMS_KEYWORD)
}

export function filterFormsCategories(list) {
  return (list || []).filter(isFormsCategory)
}

export function filterFormsArticles(list, categoryIds) {
  return (list || []).filter(item => categoryIds.includes(item.cate_id))
}

export function sortCategoryList(categories) {
  return categories.slice().sort((a, b) => {
    const sortA = Number(a.sort)
    const sortB = Number(b.sort)
    const aSort = Number.isFinite(sortA) ? sortA : 0
    const bSort = Number.isFinite(sortB) ? sortB : 0
    if (aSort !== bSort) return aSort - bSort
    return Number(a.id) - Number(b.id)
  })
}
